<template>
    <div class="body">

        <div style="height: 44px;">
            <!-- 选项卡 -->
            <div id="top" class="nav-tab" style="position: fixed;top:0;left:0;">
                <ul style="height:100%;">
                    <li v-for="(item , index) in tabData" :key="index"
                        :class="{active : item == currentTab}">
                        <a href="javascript:;" @click="switchTab(item)"
                           :class="{active : item == currentTab}">{{item.name}}</a>
                    </li>
                    <div>
                        <div style="width:14px;height:15px;position: absolute;top: 16px;right: 18px;">
                            <router-link to="/search">
                                <i class="icon whiteSearchIcon" style="width:14px;height:15px;"></i>
                            </router-link>
                        </div>
                    </div>

                </ul>
            </div>
        </div>

        <!-- 模块切换 -->
        <div class="content">
            <component :is="currentTab ?  currentTab.id : ''"></component>
        </div>
        <!-- 底部菜单栏 -->
        <bottomMenu ref="bottomMenu" activePath="/learn"></bottomMenu>
    </div>
</template>
<script>

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// 底部导航
import bottomMenu from '@/components/bottomMenu';

// config
import appConfig from '@/appConfig';

// 课程
import course from './course'
import courseOfFamousTeacher    from '../courseOfFamousTeacher/courseList'
import specialTraining      from '../specialTraining/courseList'

// util
import browserHelper    from '@util/browserHelper';
import deviceHelper     from '@util/deviceHelper';
import arrayHelper      from '@util/arrayHelper';
import appHelper        from '@util/appHelper';
import wechatHelper     from '@util/wechatHelper';

export default {
    extends : shixunPagePart,
    data() {
        return {
            // 选项卡切换
            tabData: [
                {id: 'course', name: '精品课', path: '/learn/course'},
                {id: 'courseOfFamousTeacher', name: '专题课', path: '/learn/courseOfFamousTeacher'},
                {id: 'specialTraining', name: '特训营', path: '/learn/specialTraining'}
            ],
            // 当前模块
            currentView: 'course',
            currentTab: null,
            // 当前索引
            title: '马上学'
        }
    },

    components: {
        course, courseOfFamousTeacher, specialTraining,
        bottomMenu
    },
    methods: {

        /**
         * @param String    tabText     path in tabData
         * @param Number    index       index in tabData
         */
        switchTab: function (item) {

            this.currentTab = item;

            if (item.id === 'information' || item.id === 'shortVideo')
            {
                appHelper.redirect(item.url);
                return;
            }
            else
            {
                this.$router.push(item.path)
            }

            this.setWechatShare();
        },
        setWechatShare: function () {

            let path = this.currentTab ? this.currentTab.path : '';
            let name = this.currentTab ? this.currentTab.name : '';

            let wechatShareOptions = {
                title: appHelper.getTitle(),
                desc: this.desc,
                link: appHelper.generateShareUrl(path),
                imgUrl: appHelper.getAppIcon() // 分享图标
            };

            wechatHelper.setShare(wechatShareOptions);
        },
    },
    created() {

        this.currentTab = this.tabData[0];

        if (this.$route.path != '/learn')
        {
            this.currentTab = arrayHelper.getItemByColumn(this.tabData, 'path', this.$route.path);
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop)

        appHelper.setTitle(this.title);

        if (deviceHelper.isBrowser && browserHelper.isWechat) {
            this.setWechatShare();
        }
    },
    watch:{
        $route(to){

            // 同页面不同参数需要使用函数加载新数据
            if (to.path.indexOf('/learn') === 0)
            {
                appHelper.setTitle(this.title);

                if (deviceHelper.isBrowser && browserHelper.isWechat) {
                    this.setWechatShare();
                }
            }

        },
    },
}
</script>
<style scoped lang="scss">
.body {
    background: #fff;

}

div, ul, li, input {
    margin: 0;
    padding: 0;
}

// 选项卡
.nav-tab {
    width: 100%;
    height: 44px;
    // left: 2%;
    z-index: 1;
    background: hsla(36, 100%, 57%, 1);
    margin: 0 auto;
    ul {
        overflow: hidden;
        // margin-left: 3%;
        margin-left: 18px;
        list-style: none;
        li {
            float: left;
            //margin-right: 24px;
            margin-right: 12px;
            margin-top: 16px;
            margin-bottom: 20px;

            &.active {
                margin-top: 11px;
            }
        }
        a {
            font-size: 16px;

            font-weight: 400;
            line-height: 14px;
            color: white;

            display: block;
        }
        .active {

            font-size: 20px;

            font-weight: 500;
            line-height: 14px;

        }
        .active:after {
            content: '';
            width: 19px;
            height: 6px;
            background-size: 100% 100%;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAMCAYAAAAOCs/+AAABC0lEQVQ4jc3TQStEYRTG8SmTzZSNjWzExsI3mM1VplCyF+UbiJUNGkpWbFkoSmRlpayUzyALJdlY2LCSZORn4codZu5c153JU6feep/zPv9z6s3l/rswhgUELc4dxCVecIBC9HLZl16x3iKocTyp1nzU8OCnztDfJKB2rIZL+K79qPG6hgGesYGuDKGmY/JgImoeRiXGXMEeRlLC9GIWNzEZsFaruYi7Bo2fWzzGEqYQoCdSQVgz2MYF3hK8uxg3WTeOEjySpa5QTLr6Es6bDPTo4wMUGhNVw7VhFKcZA91jBR2/AqoD2Yc5nKSEucUmhpD/M1AdyDwGMIkytrCDQ+yG53I4SAmdaXLeAfTgUFrbR04dAAAAAElFTkSuQmCC');
            background-repeat: no-repeat;

            border-radius: 3px;
            // width: 25px;
            // height: 3px;
            // border-radius: 2px;
            // background: #ff6767;
            display: block;
            margin: 8px auto;
        }
    }
}

// 搜索框
.search {
    width: 95%;
    height: 28px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 16px;
    input {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background: #f6f6f6;
        border: 0;
        border-radius: 14px;
        padding-left: 15px;
    }
    div {
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -75px;
        width: 150px;
        height: 100%;
        line-height: 28px;
        color: #acacac;
        .search-icon {
            position: absolute;
            top: 9px;
            left: 9px;
            width: 12px;
            height: 12px;
        }
        span {
            position: absolute;
            top: 0;
            left: 25px;

            font-size: 12px;

            font-weight: 400;
            color: #ACACAC;

        }
    }
}

</style>
